<div class="page">
    <h2 class="page-title">{{'Formulaire.title' | translate}}</h2>

    <div class="page-content">
        <div *ngIf="idCompany; else introTemplate" class="alert info">
            <h5>{{'Formulaire.Alert.title' | translate}}</h5>
            <p class="gs1-small">{{'Formulaire.Alert.text' | translate}}</p>
        </div>

        <ng-template #introTemplate>
            <div class="intro">
                <p>{{'Formulaire.intro' | translate}}</p> 
                <button *ngIf="!form" (click)="generateForm()" gs1Button [name]="'profile-modify'" [thin]="true" [appearance]="'outlined'">{{'Formulaire.modify' | translate}}</button>
            </div>
        </ng-template>
        
        <form [formGroup]="form" *ngIf="form">
            <div class="page-part">
                <gs1-form-group [label]="'Formulaire.InfoPro.title' | translate">
                    <gs1-select-wrapper>
                        <label for="fonction">{{'Formulaire.InfoPro.fonction' | translate}}</label>
                         <ng-select formControlName="jobId" name="'fonction'" [clearable]="false" [bindLabel]="'label'" [bindValue]="'value'" [items]="listsJobs" [searchable]="false"></ng-select> 
                    </gs1-select-wrapper>
                    <div class="divided-section">
                        <gs1-phone class="mid-input" formControlName="telPrincipal" [name]="'telPrincipal'" [label]="'Formulaire.InfoPro.phone' | translate"></gs1-phone>
                        <gs1-phone class="mid-input" formControlName="telSecondaire" [name]="'telSecondaire'" [label]="'Formulaire.InfoPro.phone-2' | translate"></gs1-phone>
                    </div>
                    <gs1-input [label]="'Formulaire.InfoPro.adresse' | translate" formControlName="adresse" [name]="'adresse'"></gs1-input>
                    <gs1-input [label]="'Formulaire.InfoPro.complement-adresse' | translate" formControlName="complementAdresse" [name]="'complementAdresse'"></gs1-input>
                    <div class="divided-section">
                        <gs1-input class="mid-input" [label]="'Formulaire.InfoPro.postal' | translate" formControlName="codePostal" [name]="'codePostal'"></gs1-input>
                        <gs1-input class="mid-input" [label]="'Formulaire.InfoPro.ville' | translate" formControlName="ville" [name]="'ville'"></gs1-input>
                    </div>
                    <gs1-select-wrapper>
                        <label for="fonction">{{'Formulaire.InfoPro.pays' | translate}}</label>
                        <ng-select formControlName="pays" name="'pays'" [clearable]="false" [bindLabel]="'name'" [bindValue]="'alpha2Code'" [items]="countriesList" [searchable]="true"></ng-select>
                    </gs1-select-wrapper>
                </gs1-form-group>
                <gs1-form-group *ngIf = "selectedSubs" [label]="'Formulaire.Subscription.title' | translate">
                    <div class="full">
                        <span class="gs1-color-ui-6 gs1-little" style="margin-bottom: 1.5rem;">{{'Formulaire.Subscription.label' | translate}}</span>
                        <gs1-checkbox-group  [linear]="false" formArrayName="subscriptions" class="subs-checkbox">
                            <gs1-checkbox *ngFor="let sub of subscriptionsForm.controls;let i = index" [formControlName]="i" [checked]="sub.value" [name]="selectedSubs[i].label" [label]="selectedSubs[i].label" (change)="selectSub()">
                            </gs1-checkbox>
                        </gs1-checkbox-group>
                        <gs1-toggle [color]="'blue'" formControlName ="receiveAllSubs" [name]="'receiveAll'" (change)="toggleReceiveAll()">{{'Formulaire.Subscription.switch1' | translate}}</gs1-toggle>
                        <gs1-toggle [color]="'blue'" formControlName ="receiveNoneSubs" [name]="'recieveNone'" (change)="toggleReceiveNone()">{{'Formulaire.Subscription.switch2' | translate}}</gs1-toggle>
                    </div>
                </gs1-form-group>
            </div>
        
            <div class="page-part">
                <ng-container *ngTemplateOutlet="identifiantTemplate"></ng-container>
            
                <gs1-form-group [label]="'Formulaire.InfoPerso.title' | translate">
                     <gs1-radios [label]="'Formulaire.InfoPerso.genre' | translate" [linear]="true">
                        <gs1-radio formControlName="genre" [name]="gender.mme.label" [value]="gender.mme.value" [label]="'Formulaire.InfoPerso.mme' | translate"></gs1-radio>
                        <gs1-radio formControlName="genre" [name]="gender.mr.label" [value]="gender.mr.value" [label]="'Formulaire.InfoPerso.mr' | translate"></gs1-radio>
                    </gs1-radios>
                    <div class="divided-section">
                        <gs1-input class="mid-input" [label]="'Formulaire.InfoPerso.nom' | translate" formControlName="nom" [name]="'nom'"></gs1-input>
                        <gs1-input class="mid-input" [label]="'Formulaire.InfoPerso.prenom' | translate" formControlName="prenom" [name]="'prenom'"></gs1-input>
                    </div>
                </gs1-form-group>

                <div *ngIf="idCompany; else profilTemplate">
                    <gs1-checkbox formControlName="cguAcceptation" [name]="'cgu'">
                        <span (click)="clickCGU($event)" [innerHTML]="'Formulaire.CGU.label' | translate"></span>
                    </gs1-checkbox>
                    <p [innerHTML]="'Formulaire.CGU.legal' | translate" class="gs1-legal gs1-color-ui-5"></p>
                </div>
            </div>
            <div class="button-row">
                <button gs1Button [name]="'profile-cancel'" *ngIf="!accountNumber" [appearance]="'outlined'" (click)="cancelEdit()">{{'Formulaire.cancel' | translate}}</button>
                <button gs1Button [name]="'profile-save'" (click)="updateContact()" [disabled]="form.invalid" [pending]="sendingForm">{{(accountNumber ? 'Formulaire.validate' : 'Formulaire.save') | translate}}</button>
            </div>
        </form>

        <div class="form-placeholder" *ngIf="!form && !idCompany && infoPerso">
            <div class="page-part"> 
                <gs1-form-group [label]="'Formulaire.InfoPro.title' | translate">
                    <div class="select-placeholder">
                        <p class="gs1-color-ui-6 gs1-little">{{'Formulaire.InfoPro.fonction' | translate}}</p>
                       <p class="gs1-color-blue gs1-little">{{getLabel(listsJobs, infoPerso.jobId)}}</p> 
                    </div>
                    <div class="divided-section">
                        <div class="half">
                            <p class="gs1-color-ui-6 gs1-little">{{'Formulaire.InfoPro.phone' | translate}}</p>
                            <p class="gs1-color-blue gs1-little">{{infoPerso.telPrincipal}}</p>
                        </div>
                        <div class="half">
                            <p class="gs1-color-ui-6 gs1-little">{{'Formulaire.InfoPro.phone-2' | translate}}</p>
                            <p class="gs1-color-blue gs1-little">{{infoPerso.telSecondaire}}</p>
                        </div>
                    </div>
                    <div class="full">
                        <p class="gs1-color-ui-6 gs1-little">{{'Formulaire.InfoPro.adresse' | translate}}</p>
                        <p class="gs1-color-blue gs1-little multi-paragraph">
                            <span>{{infoPerso.adresse}}</span>
                            <span *ngIf="infoPerso.complementAdresse">{{infoPerso.complementAdresse}}</span>
                            <span>{{infoPerso.codePostal}} {{infoPerso.ville}}</span>
                            <span *ngIf="infoPerso.pays">{{getLabelPays()}}</span>
                        </p>
                    </div>
                </gs1-form-group>
                <gs1-form-group *ngIf = "selectedSubs" [label]="'Formulaire.Subscription.title' | translate">
                    <div class="full">
                      <gs1-structured-list [singleColumn]="true" >
                            <gs1-structured-list-element>
                                <span class="gs1-color-ui-6 gs1-little" style="margin-bottom: 1.5rem;">{{'Formulaire.Subscription.label' | translate}}</span>
                                <span *ngFor ="let item of selectedSubs" [ngClass]="{'gs1-color-blue' : item.status, 'gs1-color-ui-5' : !item.status}" class="gs1-little subs-items"> <i class="bi bi-check-circle-fill"></i>{{item.label}}
                                    <span *ngIf = "item.tooltip" class="tooltip-mark" [matTooltip]="item.tooltip" [matTooltipPosition]="'right'">?</span></span>
                            </gs1-structured-list-element>
                        </gs1-structured-list>
                    </div>
                </gs1-form-group>
            </div>
            <div class="page-part">
                <ng-container *ngTemplateOutlet="identifiantTemplate"></ng-container>

                <gs1-form-group [label]="'Formulaire.InfoPerso.title' | translate">
                    <div class="full">
                        <p class="gs1-color-ui-6 gs1-little">{{'Formulaire.InfoPerso.genre' | translate}}</p>
                        <!-- <p class="gs1-color-blue gs1-little">{{(infoPerso.genre === gender.value ? 'Formulaire.InfoPerso.mme' : 'Formulaire.InfoPerso.mr') | translate}}</p> -->
                        <p class="gs1-color-blue gs1-little">{{ gender.mme.value === infoPerso.genre ? gender.mme.label : gender.mr.label}}</p>
                    </div>
                    <div class="divided-section">
                        <div class="half">
                            <p class="gs1-color-ui-6 gs1-little">{{'Formulaire.InfoPerso.nom' | translate}}</p>
                            <p class="gs1-color-blue gs1-little">{{infoPerso.nom}}</p>
                        </div>
                        <div class="half">
                            <p class="gs1-color-ui-6 gs1-little">{{'Formulaire.InfoPerso.prenom' | translate}}</p>
                            <p class="gs1-color-blue gs1-little">{{infoPerso.prenom}}</p>
                        </div>
                    </div>
                </gs1-form-group>

                <ng-container *ngTemplateOutlet="profilTemplate"></ng-container>
            </div>
        </div>
    </div>
    
</div>

<ng-template #identifiantTemplate>
    <gs1-form-group [label]="'Formulaire.Identifiant.title' | translate">
        <div class="email-wrapper">
            <p class="gs1-color-ui-6 gs1-little">{{'Formulaire.Identifiant.email' | translate}}</p>
            <p class="gs1-color-blue gs1-little email">{{form ? form.get('email').value : infoPerso.email}} <span class="tooltip-mark" [matTooltip]="'Formulaire.Identifiant.tooltip' | translate" [matTooltipPosition]="'above'">?</span> </p>
        </div>
        <div class="password" *ngIf="!accountNumber">
            <p class="gs1-color-ui-6 gs1-little">{{'Formulaire.Identifiant.password' | translate}}</p>
            <a href="{{changePasswordUrl}}" target="_blank" gs1Button [name]="'profile-password'" [thin]="true" [appearance]="'outlined'" [color]="'blue'">{{'Formulaire.Identifiant.password-button' | translate}}</a>
        </div>
    </gs1-form-group>
</ng-template>

<ng-template #profilTemplate>
    <gs1-form-group [label]="'Formulaire.Profil.title' | translate">
        <div class="divided-section">
        <div class="mid-input">
            <p class="gs1-color-ui-6 gs1-little">{{'Formulaire.Profil.profil' | translate}}</p>
            <p class="gs1-color-blue gs1-little">{{infoPerso.roles.join(', ')}}</p>
        </div>
        <div class="mid-input">
            <p class="gs1-color-ui-6 gs1-little">{{'Formulaire.Profil.role' | translate}}</p>
            <p class="gs1-color-blue gs1-little roles"><span *ngIf="infoPerso.isMainContact" class="contact-gs1">{{'Users.Roles.main' | translate}}</span><span *ngIf="infoPerso.isBillingContact" class="contact-facturation"> {{'Users.Roles.billing' | translate}}</span> </p>
        </div>
    </div>
    </gs1-form-group>
</ng-template>

